/**
 * Derive a short, human-meaningful CONTENT tag (Options, Stocks, Dividends…)
 * from a piece of text (a name + description, or a headline + tags). Used so
 * the card badge says what the thing is ABOUT instead of repeating its kind
 * ("AUTOMATION" / "USER STORY").
 *
 * Order matters: most specific keywords win first.
 */
export function contentTag(text: string): string {
  const t = (text || "").toLowerCase();
  const has = (...kw: string[]) => kw.some((k) => t.includes(k));

  if (has("dark pool")) return "Dark Pool";
  if (has("news", "headline", "breaking")) return "News";
  if (has("insider", "form 4")) return "Insider";
  if (has("dividend", "drip", "yield", "cash flow", "income")) return "Dividends";
  if (has("earnings", "iv crush", "straddle")) return "Earnings";
  if (has("crypto", "doge", "bitcoin", "btc", "ethereum", "eth ")) return "Crypto";
  if (has("futures", "overnight", "pre-market", "premarket", "session", "0dte")) return "Futures";
  if (has("wheel", "covered call", "cash-secured")) return "Options";
  if (
    has(
      "option",
      "call",
      "put",
      "spread",
      "gamma",
      "flow",
      "whale",
      "iv ",
      "volatility",
      "skew",
    )
  )
    return "Options";
  if (has("swing")) return "Swing";
  if (has("screen", "scanner", "scan")) return "Screener";
  if (has("macro", "fed", "fomc", "cpi")) return "Macro";
  return "Stocks";
}
